// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-modernScreen .people-toolbar__heading {
  align-items: center;
}

.users-modernScreen .users-toolbarSearch {
  width: 100%;
  margin-top: 10px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  transform: none;
}

@media (max-width: 1100px) {
  .users-modernScreen .users-toolbarSearch {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 620px) {
  .users-modernScreen .users-toolbarSearch {
    grid-template-columns: 1fr;
  }
}

.users-modernTable {
  min-width: 980px;
}

.users-avatar--image {
  object-fit: cover;
}

.users-modernScreen .people-avatar {
  position: relative;
  overflow: hidden;
}

.users-modernScreen .people-avatar img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: cover;
}

/* The details drawer is rendered next to, rather than inside, users-modernScreen. */
.usersPage .people-drawer .people-avatar {
  position: relative;
  overflow: hidden;
}

.usersPage .people-drawer .people-avatar img {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  border-radius: inherit;
  object-fit: cover;
}

.users-modernScreen .people-columns__item--locked input {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--slate-100, #f1f5f9);
  opacity: 0.45;
}

.users-modernScreen .people-selection__reports {
  margin-left: 8px;
  padding-left: 16px;
  border-left: 1px solid var(--border-default, #cbd5e1);
}

.users-chipList,
.users-accessChips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.users-roleChip,
.users-accessReadChip,
.users-chipMore {
  min-height: 24px;
  padding: 0 9px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  background: #eef6fc;
  color: var(--brand-primary, #227ebd);
  font-size: 12px;
  font-weight: 750;
}

.users-chipMore {
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
}

.users-status {
  min-height: 24px;
  padding: 0 9px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 750;
}

.users-status--active {
  background: #e8f7ee;
  color: #268049;
}

.users-drawerFoot {
  flex-wrap: wrap;
}

.users-drawerFoot .people-btn {
  flex: 1 1 calc(50% - 8px);
}

.users-detailList {
  display: flex;
  flex-direction: column;
  gap: 0;
  color: var(--text-body, #334155);
}

.users-detailRow {
  min-height: 48px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  display: grid;
  grid-template-columns: 116px minmax(0, 1fr);
  gap: 14px;
  align-items: center;
}

.users-detailRow:first-child {
  padding-top: 0;
}

.users-detailRow > span {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.users-detailRow > strong {
  min-width: 0;
  color: var(--text-body, #334155);
  font-size: 14px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.users-detailRow .users-chipList {
  display: inline-flex;
}

.users-accessEditor {
  display: flex;
  flex-direction: column;
  gap: 0;
  color: var(--text-body, #334155);
}

.users-accessSection {
  padding: 16px 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.users-accessSection:first-child {
  padding-top: 0;
}

.users-accessSection__head {
  min-height: 30px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.users-accessSection__head > span,
.users-accessLabel {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.users-roleCards {
  display: grid;
  gap: 10px;
}

.users-roleCard {
  padding: 12px 13px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--slate-25, #fbfdff);
}

.users-roleCard__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.users-roleCard__meta {
  margin-top: 9px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 650;
}

.users-roleStatus {
  min-height: 22px;
  padding: 0 8px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.users-roleStatus--active {
  background: #e8f7ee;
  color: #268049;
}

.users-roleCard__sports {
  margin-top: 11px;
}

.users-accessChip {
  min-height: 26px;
  padding: 0 5px 0 10px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: color-mix(in srgb, var(--users-chip-color, #227ebd) 13%, #ffffff);
  color: var(--users-chip-color, #227ebd);
  font-size: 12px;
  font-weight: 750;
}

.users-accessChip i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--users-chip-color, #227ebd);
}

.users-accessChip button {
  width: 18px;
  height: 18px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
}

.users-accessChip button:hover {
  background: rgba(15, 23, 42, 0.08);
}

.users-accessAddSelect {
  min-height: 28px;
  max-width: 180px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #ffffff);
  color: var(--text-muted, #64748b);
  padding: 0 9px;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.usersPage .people-drawer__close {
  flex: 0 0 32px;
  align-self: flex-start;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.users-accessAddSelect:focus {
  outline: none;
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}

.users-accessEmpty {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  color: var(--text-subtle, #94a3b8);
  font-size: 12px;
  font-weight: 600;
}

@media (max-width: 620px) {
  .users-drawerFoot .people-btn {
    flex-basis: 100%;
  }

  .users-detailRow {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .users-accessSection__head {
    align-items: flex-start;
    flex-direction: column;
  }
}

.users-linkedChild {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.users-parentRoleCard__count {
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
}

.users-parentPermissions {
  margin-top: 10px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.users-parentPermission + .users-parentPermission {
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.users-parentPermission .users-linkedChild {
  margin: 0;
  padding: 11px 0;
  border: 0;
}

.users-linkedChild__remove {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border: 1px solid #f0b8c1;
  border-radius: 7px;
  background: #fff5f6;
  color: #b4233b;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.users-linkedChild__remove:hover {
  background: #fde8eb;
}

.users-linkedChild__card,
.users-linkedChild__fallback {
  margin-top: 7px;
  padding: 9px 10px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: #ffffff;
}

.users-linkedChild__card {
  display: flex;
  align-items: center;
  gap: 9px;
}

.users-linkedChild__avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #e8f2fb;
  color: var(--brand-primary, #227ebd);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
  overflow: hidden;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
}

.users-linkedChild__avatar > span {
  display: block;
  line-height: 1;
  transform: translateY(0.5px);
}

.users-linkedChild__main {
  min-width: 0;
  flex: 1 1 auto;
}

.users-linkedChild__fallback {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.users-linkedChild__main strong,
.users-linkedChild__main span {
  display: block;
}

.users-linkedChild__main strong {
  color: var(--text-heading, #0f172a);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.users-linkedChild__main span,
.users-linkedChild__fallback {
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 650;
  line-height: 1.25;
}
.users-filter {
  grid-template-columns: repeat(3, minmax(150px, 1fr)) auto;
  align-items: end;
  column-gap: 16px;
  padding: 16px;
  border-color: var(--border-subtle, #dbe3ec);
  background: var(--surface-subtle, #f8fafc);
  box-shadow: none;
}

.users-filter .people-filter__field {
  gap: 7px;
}

.users-filter .people-filter__field > span {
  color: var(--text-body, #334155);
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.users-filter .users-filter__select {
  width: 100%;
  height: 38px;
  padding: 0 36px 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  appearance: none;
  background-color: var(--surface-card, #fff);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 11px center;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 13px;
  line-height: 1;
  font-weight: 650;
  cursor: pointer;
  transition: border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease;
}

.users-filter .users-filter__select--placeholder {
  color: var(--text-muted, #64748b);
  font-weight: 550;
}

.users-filter .users-filter__select:hover {
  border-color: var(--border-strong, #94a3b8);
}

.users-filter .users-filter__select:focus {
  outline: none;
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));
}

.users-filter .users-filter__select option {
  background: #fff;
  color: var(--text-strong, #0f172a);
  font-weight: 500;
}

.users-filter .people-filter__actions {
  align-self: end;
  min-height: 38px;
  transform: translateY(-9px);
}

.users-filter .people-filter__actions .people-btn {
  height: 38px;
  min-height: 38px;
}

.people-chipFilter {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
.people-chipFilter legend {
  margin-bottom: 7px;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 750;
}
.people-chipFilter > input {
  width: 100%;
  height: 36px;
  margin-bottom: 8px;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-strong, #142033);
  font: inherit;
  font-size: 13px;
  outline: none;
}
.people-chipFilter > input:focus {
  border-color: var(--action-primary, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);
}
.people-chipFilter__body {
  max-height: 230px;
  overflow-y: auto;
}
.people-chipFilter__group + .people-chipFilter__group {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--border-subtle, #e5e7eb);
}
.people-chipFilter__groupTitle {
  display: flex;
  align-items: baseline;
  gap: 7px;
  margin-bottom: 7px;
}
.people-chipFilter__groupTitle strong {
  color: var(--text-strong, #142033);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
}
.people-chipFilter__groupTitle span {
  color: var(--text-muted, #64748b);
  font-size: 11px;
}
.people-chipFilter__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.people-chipFilter__chip {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: #fff;
  color: var(--text-body, #334155);
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
}
.people-chipFilter__chip:hover {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eff6ff);
}
.people-chipFilter__chip.is-selected:not([style]) {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.people-chipFilter__empty {
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

@media (max-width: 760px) {
  .users-filter {
    grid-template-columns: repeat(2, minmax(150px, 1fr));
  }
}

.eEventPrintModal.modal-dialog {
  max-width: 760px !important;
  font-family: var(--font-body, inherit);
}

.eEventPrintModal .modal-body {
  padding: 18px 20px 20px !important;
}

.eEventPrintModal__intro {
  margin-bottom: 18px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.5;
}

.eEventPrintModal__group + .eEventPrintModal__group {
  margin-top: 20px;
}

.eEventPrintModal__groupTitle {
  margin: 0 0 8px;
  color: var(--text-subtle, #94a3b8);
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.07em;
  line-height: 1.3;
  text-transform: uppercase;
}

.eEventPrintModal__list {
  display: grid;
  gap: 8px;
}

.eEventPrintModal__item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}

.eEventPrintModal__item:hover:not(:disabled) {
  border-color: var(--blue-400, #55a4d6);
  background: var(--blue-50, #eef8ff);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.eEventPrintModal__item:focus-visible {
  outline: 2px solid var(--blue-500, #2684c7);
  outline-offset: 2px;
}

.eEventPrintModal__item:disabled {
  background: var(--slate-25, #f8fafc);
  cursor: not-allowed;
  opacity: 0.62;
}

.eEventPrintModal__itemIcon {
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--blue-50, #eef8ff);
  color: var(--blue-700, #17659a);
}

.eEventPrintModal__itemIcon svg {
  width: 19px;
  height: 19px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.eEventPrintModal__itemCopy {
  min-width: 0;
  flex: 1;
}

.eEventPrintModal__itemHeading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 750;
  line-height: 1.35;
}

.eEventPrintModal__format {
  display: inline-flex;
  flex: 0 0 auto;
  padding: 2px 6px;
  border-radius: 5px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.eEventPrintModal__itemDescription {
  display: block;
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.4;
}

.eEventPrintModal__arrow {
  flex: 0 0 auto;
  color: var(--text-subtle, #94a3b8);
  font-size: 24px;
  line-height: 1;
}

@media (max-width: 560px) {
  .eEventPrintModal.modal-dialog {
    width: calc(100vw - 24px) !important;
  }

  .eEventPrintModal .modal-body {
    padding: 15px !important;
  }

  .eEventPrintModal__item {
    align-items: flex-start;
    padding: 11px;
  }

  .eEventPrintModal__itemHeading {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }

  .eEventPrintModal__arrow {
    display: none;
  }
}

/* Activity report parameters use the same field system as Extended team sheet. */
.eEventReportParametersModal.modal-dialog {
  max-width: 660px !important;
  font-family: var(--font-body, inherit);
}

.eEventReportParametersModal .modal-content {
  border-color: var(--border-subtle, #e3e8ef) !important;
  border-radius: 16px !important;
}

.eEventReportParametersModal .modal-header {
  min-height: 76px;
  padding: 14px 18px !important;
  background: #fff !important;
}

.eReportModalTitle {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}
.eReportModalTitle__icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: var(--blue-50, #eef8ff);
  color: var(--blue-700, #17659a);
}
.eReportModalTitle__icon svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.eReportModalTitle__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
}
.eReportModalTitle__name {
  color: var(--text-strong, #142033);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
}
.eReportModalTitle__category {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  font-weight: 500;
}
.eEventReportParametersModal .modal-body {
  padding: 0 !important;
  background: #fff;
}
.eEventReportParametersModal__body .eReportForm {
  display: block !important;
  color: var(--text-body, #334155);
  font-size: 13px;
}
.eEventReportParametersModal__body .eReportDescription {
  margin: 18px 24px 8px;
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 11px;
  background: var(--slate-25, #f8fafc);
  color: var(--text-body, #334155);
  line-height: 1.55;
}
.eEventReportParametersModal__body .eReportSection {
  margin: 16px 24px 0;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-subtle, #e3e8ef);
}
.eEventReportParametersModal__body .eReportSection__heading {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
}
.eEventReportParametersModal__body .eReportSection__icon {
  display: inline-flex;
  width: 26px;
  height: 26px;
  flex: 0 0 26px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--blue-50, #eef8ff);
  color: var(--blue-700, #17659a);
  font-size: 12px;
  font-weight: 800;
}
.eEventReportParametersModal__body .eReportSection__title {
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 750;
}
.eEventReportParametersModal__body .eReportSection__hint {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
}
.eEventReportParametersModal__body .eReportDateRange {
  display: block;
}
.eEventReportParametersModal__body .eReportDateRange__picker {
  width: 100%;
}
.eEventReportParametersModal__body .eReportDateRange label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  color: #526174;
  font-size: 11.5px;
  font-weight: 700;
}
.eEventReportParametersModal__body .eReportDateRange input {
  width: 100%;
  height: 42px;
  padding: 0 11px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #334155;
  font: inherit;
  font-size: 13px;
}
.eEventReportParametersModal__body .eReportDateRange input:focus {
  border-color: #368fca;
  box-shadow: 0 0 0 3px rgba(54, 143, 202, 0.12);
  outline: 0;
}
.eEventReportParametersModal__body .eReportToggleList {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 11px;
}
.eEventReportParametersModal__body .eReportToggle {
  display: flex;
  min-height: 56px;
  align-items: center;
  gap: 16px;
  padding: 10px 13px;
  border-top: 1px solid var(--border-subtle, #e3e8ef);
  background: #fff;
}
.eEventReportParametersModal__body .eReportToggle:first-child {
  border-top: 0;
}
.eEventReportParametersModal__body .eReportToggle__copy {
  min-width: 0;
  flex: 1;
}
.eEventReportParametersModal__body .eReportToggle__label {
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 650;
}
.eEventReportParametersModal__body .eReportToggle__hint {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}
.eEventReportParametersModal__body .eReportToggle .sit-switch {
  flex: 0 0 auto;
  margin: 0;
}
.eEventReportParametersModal__body .eReportActions {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 18px;
  padding: 14px 24px;
  border-top: 1px solid var(--border-subtle, #e3e8ef);
  background: var(--slate-25, #f8fafc);
}
.eEventReportParametersModal__body .eReportActions__status {
  flex: 1;
  color: var(--text-muted, #64748b);
  font-size: 12px;
}
.eEventReportParametersModal__body .eDsButton {
  min-height: 40px;
  padding: 8px 15px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.eEventReportParametersModal__body .eDsButton--secondary {
  border: 1px solid var(--border-default, #cfd8e3);
  background: #fff;
  color: var(--text-strong, #142033);
}
.eEventReportParametersModal__body .eDsButton--primary {
  border: 1px solid var(--blue-600, #1f78b4);
  background: var(--blue-600, #1f78b4);
  color: #fff;
}
.eEventReportParametersModal__body .eDsButton--primary:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

@media (max-width: 560px) {
  .eEventReportParametersModal.modal-dialog {
    width: calc(100vw - 24px) !important;
  }
  .eEventReportParametersModal__body .eReportDescription,
  .eEventReportParametersModal__body .eReportSection {
    margin-right: 14px;
    margin-left: 14px;
  }
  .eEventReportParametersModal__body .eReportDateRange {
    grid-template-columns: 1fr;
  }
  .eEventReportParametersModal__body .eReportActions {
    align-items: stretch;
    flex-direction: column;
    padding: 12px 14px;
  }
  .eEventReportParametersModal__body .eReportActions__status,
  .eEventReportParametersModal__body .eDsButton {
    width: 100%;
  }
}
.peopleRoleActionModal.modal-dialog {
  max-width: 560px !important;
}
.peopleRoleActionModal .modal-content {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  overflow: hidden;
}
.peopleRoleActionModal .modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: #fff;
}
.peopleRoleActionModal .modal-title {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));
  font-size: 18px;
  font-weight: 800;
}
.peopleRoleActionModal .modal-body {
  padding: 18px 20px 20px !important;
}
.userRoleActionForm {
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.userRoleActionForm__intro {
  margin: 0 0 12px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.5;
}
.userRoleActionForm__summary {
  min-height: 44px;
  margin-bottom: 14px;
  padding: 10px 12px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 8px;
  background: var(--slate-50, #f8fafc);
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
}
.userRoleActionForm__label {
  display: block;
  margin-bottom: 7px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
}
.userRoleActionForm__list {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
}
.userRoleActionForm__row {
  min-height: 44px;
  margin: 0;
  padding: 7px 12px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.userRoleActionForm__row:first-child {
  border-top: 0;
}
.userRoleActionForm__row .sit-switch {
  flex: 0 0 auto;
  margin: 0;
}
.userRoleActionForm__actions {
  margin: 18px -20px -20px;
  padding: 14px 20px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-50, #f8fafc);
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.userRoleActionForm__actions .sit-btn--primary:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.peopleDangerModal.modal-dialog {
  max-width: 540px !important;
}
.peopleDangerModal .modal-content {
  overflow: hidden;
  border: 1px solid #fecaca;
  border-radius: 14px;
}
.peopleDangerModal .modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #fee2e2;
  background: #fff;
}
.peopleDangerModal .modal-title {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));
  font-size: 18px;
  font-weight: 800;
}
.peopleDangerModal .modal-body {
  padding: 0 !important;
}
.peopleDangerModal__content {
  padding: 20px 20px 0;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.peopleDangerModal__icon {
  width: 44px;
  height: 44px;
  margin-bottom: 14px;
  border-radius: 12px;
  background: #fef2f2;
  color: #b42318;
  display: flex;
  align-items: center;
  justify-content: center;
}
.peopleDangerModal__icon svg {
  width: 23px;
  height: 23px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.peopleDangerModal__copy strong,
.peopleDangerModal__warning strong {
  display: block;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.4;
}
.peopleDangerModal__copy p,
.peopleDangerModal__warning p {
  margin: 5px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.5;
}
.peopleDangerModal__warning {
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fef2f2;
}
.peopleDangerModal__warning strong {
  color: #991b1b;
}
.peopleDangerModal__warning p {
  color: #7f1d1d;
}
.peopleDangerModal__actions {
  margin: 20px -20px 0;
  padding: 14px 20px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-50, #f8fafc);
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.peopleDangerModal__actions .sit-btn--danger {
  border: 1px solid #b42318;
  background: #b42318;
  color: #fff;
}
.peopleDangerModal__actions .sit-btn--danger:hover {
  border-color: #912018;
  background: #912018;
}
.eEventReportParametersModal__body .eReportSection__required {
  margin-left: 3px;
  color: var(--red-500, #d92d20);
}
.eEventReportParametersModal .modal-content,
.eEventReportParametersModal .modal-body,
.eEventReportParametersModal__body {
  overflow: visible !important;
}
.eEventReportParametersModal .eReportDateRange .sit-dp__pop {
  z-index: 1080;
}
.accountSetupReminderModal.modal-dialog { max-width: 600px !important; }
.accountSetupReminderModal .modal-content { border: 0; border-radius: 16px; overflow: hidden; }
.accountSetupReminderModal .modal-header { padding: 18px 22px; border-bottom: 1px solid #e2e8f0; }
.accountSetupReminderModal .modal-body { padding: 0 !important; }
.accountSetupReminder { padding: 22px; color: #334155; font-family: var(--font-body, 'Public Sans', system-ui, sans-serif); }
.accountSetupReminder__summary { display: flex; flex-direction: column; gap: 5px; padding: 16px; border-radius: 12px; background: #eff6ff; }
.accountSetupReminder__summary strong { color: #0f172a; font-size: 16px; }
.accountSetupReminder__summary span { color: #475569; font-size: 13px; }
.accountSetupReminder__notice { margin-top: 12px; padding: 12px 14px; border: 1px solid #fed7aa; border-radius: 10px; background: #fff7ed; color: #9a3412; font-size: 13px; line-height: 1.5; }
.accountSetupReminder__field { display: flex; flex-direction: column; gap: 7px; margin-top: 20px; }
.accountSetupReminder__field > span { color: #0f172a; font-size: 13px; font-weight: 700; }
.accountSetupReminder__field select { width: 100%; height: 42px; padding: 0 12px; border: 1px solid #cbd5e1; border-radius: 9px; background: #fff; color: #0f172a; font-size: 14px; }
.accountSetupReminder__field small { color: #64748b; line-height: 1.45; }
.accountSetupReminder__error { margin-top: 14px; padding: 11px 13px; border-radius: 9px; background: #fef2f2; color: #b42318; font-size: 13px; }
.accountSetupReminder__success { display: flex; align-items: center; flex-direction: column; padding: 12px 20px 8px; text-align: center; }
.accountSetupReminder__successIcon { display: grid; width: 64px; height: 64px; margin-bottom: 16px; place-items: center; border: 8px solid #dcfae6; border-radius: 50%; background: #17b26a; color: #fff; font-size: 22px; box-shadow: 0 0 0 6px #ecfdf3; }
.accountSetupReminder__successEyebrow { margin-bottom: 7px; color: #067647; font-size: 12px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; }
.accountSetupReminder__success strong { max-width: 410px; color: #101828; font-size: 21px; line-height: 1.3; }
.accountSetupReminder__success p { margin: 10px 0 0; color: #475467; font-size: 14px; line-height: 1.5; }
.accountSetupReminder__success small { max-width: 430px; margin-top: 16px; padding: 11px 14px; border-radius: 10px; background: #f0f9ff; color: #475467; font-size: 12px; line-height: 1.5; }
.accountSetupReminder__actions { display: flex; justify-content: flex-end; gap: 10px; margin: 22px -22px -22px; padding: 14px 22px; border-top: 1px solid #e2e8f0; background: #f8fafc; }
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Users/AllUsers/Users.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sDAAsD;EACtD,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6EAA6E;EAC7E,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,oCAAoC;EACpC,wCAAwC;EACxC,iCAAiC;EACjC,cAAc;EACd,mEAAmE;EACnE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,+CAA+C;EAC/C,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yDAAyD;EACzD,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gDAAgD;EAChD,oCAAoC;EACpC,gBAAgB;EAChB,2CAA2C;EAC3C,wQAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,mEAAmE;EACnE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;AACzF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;AACA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,uFAAuF;AACzF;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,iFAAiF;AACjF;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,sDAAsD;EACtD,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sDAAsD;AACxD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,OAAO;AACT;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;AACA;EACE,OAAO;EACP,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;EACpB;EACA;;IAEE,WAAW;EACb;AACF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,8FAA8F;EAC9F,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,mEAAmE;AACrE;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;EACpC,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,8FAA8F;EAC9F,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,mEAAmE;AACrE;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;EACpC,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;AACA;;;EAGE,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;AACA,0CAA0C,2BAA2B,EAAE;AACvE,4CAA4C,SAAS,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC9F,2CAA2C,kBAAkB,EAAE,gCAAgC,EAAE;AACjG,yCAAyC,qBAAqB,EAAE;AAChE,wBAAwB,aAAa,EAAE,cAAc,EAAE,mEAAmE,EAAE;AAC5H,iCAAiC,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC3I,wCAAwC,cAAc,EAAE,eAAe,EAAE;AACzE,sCAAsC,cAAc,EAAE,eAAe,EAAE;AACvE,gCAAgC,gBAAgB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC9L,+BAA+B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAClG,sCAAsC,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACzF,sCAAsC,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AACpL,qCAAqC,cAAc,EAAE,iBAAiB,EAAE;AACxE,+BAA+B,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC/I,iCAAiC,aAAa,EAAE,mBAAmB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AACzI,qCAAqC,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE,6BAA6B,EAAE;AAC1P,wCAAwC,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AACjK,wCAAwC,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC7G,mCAAmC,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACxG,uCAAuC,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC5L,iCAAiC,aAAa,EAAE,yBAAyB,EAAE,SAAS,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,mBAAmB,EAAE","sourcesContent":[".users-modernScreen .people-toolbar__heading {\n  align-items: center;\n}\n\n.users-modernScreen .users-toolbarSearch {\n  width: 100%;\n  margin-top: 10px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  transform: none;\n}\n\n@media (max-width: 1100px) {\n  .users-modernScreen .users-toolbarSearch {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 620px) {\n  .users-modernScreen .users-toolbarSearch {\n    grid-template-columns: 1fr;\n  }\n}\n\n.users-modernTable {\n  min-width: 980px;\n}\n\n.users-avatar--image {\n  object-fit: cover;\n}\n\n.users-modernScreen .people-avatar {\n  position: relative;\n  overflow: hidden;\n}\n\n.users-modernScreen .people-avatar img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n  object-fit: cover;\n}\n\n/* The details drawer is rendered next to, rather than inside, users-modernScreen. */\n.usersPage .people-drawer .people-avatar {\n  position: relative;\n  overflow: hidden;\n}\n\n.usersPage .people-drawer .people-avatar img {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: inherit;\n  object-fit: cover;\n}\n\n.users-modernScreen .people-columns__item--locked input {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--slate-100, #f1f5f9);\n  opacity: 0.45;\n}\n\n.users-modernScreen .people-selection__reports {\n  margin-left: 8px;\n  padding-left: 16px;\n  border-left: 1px solid var(--border-default, #cbd5e1);\n}\n\n.users-chipList,\n.users-accessChips {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.users-roleChip,\n.users-accessReadChip,\n.users-chipMore {\n  min-height: 24px;\n  padding: 0 9px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  background: #eef6fc;\n  color: var(--brand-primary, #227ebd);\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.users-chipMore {\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n\n.users-status {\n  min-height: 24px;\n  padding: 0 9px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.users-status--active {\n  background: #e8f7ee;\n  color: #268049;\n}\n\n.users-drawerFoot {\n  flex-wrap: wrap;\n}\n\n.users-drawerFoot .people-btn {\n  flex: 1 1 calc(50% - 8px);\n}\n\n.users-detailList {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  color: var(--text-body, #334155);\n}\n\n.users-detailRow {\n  min-height: 48px;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  display: grid;\n  grid-template-columns: 116px minmax(0, 1fr);\n  gap: 14px;\n  align-items: center;\n}\n\n.users-detailRow:first-child {\n  padding-top: 0;\n}\n\n.users-detailRow > span {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.users-detailRow > strong {\n  min-width: 0;\n  color: var(--text-body, #334155);\n  font-size: 14px;\n  font-weight: 700;\n  overflow-wrap: anywhere;\n}\n\n.users-detailRow .users-chipList {\n  display: inline-flex;\n}\n\n.users-accessEditor {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  color: var(--text-body, #334155);\n}\n\n.users-accessSection {\n  padding: 16px 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.users-accessSection:first-child {\n  padding-top: 0;\n}\n\n.users-accessSection__head {\n  min-height: 30px;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.users-accessSection__head > span,\n.users-accessLabel {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.users-roleCards {\n  display: grid;\n  gap: 10px;\n}\n\n.users-roleCard {\n  padding: 12px 13px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--slate-25, #fbfdff);\n}\n\n.users-roleCard__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.users-roleCard__meta {\n  margin-top: 9px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.users-roleStatus {\n  min-height: 22px;\n  padding: 0 8px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.users-roleStatus--active {\n  background: #e8f7ee;\n  color: #268049;\n}\n\n.users-roleCard__sports {\n  margin-top: 11px;\n}\n\n.users-accessChip {\n  min-height: 26px;\n  padding: 0 5px 0 10px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: color-mix(in srgb, var(--users-chip-color, #227ebd) 13%, #ffffff);\n  color: var(--users-chip-color, #227ebd);\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.users-accessChip i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--users-chip-color, #227ebd);\n}\n\n.users-accessChip button {\n  width: 18px;\n  height: 18px;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 15px;\n  line-height: 1;\n}\n\n.users-accessChip button:hover {\n  background: rgba(15, 23, 42, 0.08);\n}\n\n.users-accessAddSelect {\n  min-height: 28px;\n  max-width: 180px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #ffffff);\n  color: var(--text-muted, #64748b);\n  padding: 0 9px;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.usersPage .people-drawer__close {\n  flex: 0 0 32px;\n  align-self: flex-start;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.users-accessAddSelect:focus {\n  outline: none;\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n\n.users-accessEmpty {\n  min-height: 24px;\n  display: inline-flex;\n  align-items: center;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n@media (max-width: 620px) {\n  .users-drawerFoot .people-btn {\n    flex-basis: 100%;\n  }\n\n  .users-detailRow {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n\n  .users-accessSection__head {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n.users-linkedChild {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.users-parentRoleCard__count {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.users-parentPermissions {\n  margin-top: 10px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.users-parentPermission + .users-parentPermission {\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.users-parentPermission .users-linkedChild {\n  margin: 0;\n  padding: 11px 0;\n  border: 0;\n}\n\n.users-linkedChild__remove {\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  border: 1px solid #f0b8c1;\n  border-radius: 7px;\n  background: #fff5f6;\n  color: #b4233b;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.users-linkedChild__remove:hover {\n  background: #fde8eb;\n}\n\n.users-linkedChild__card,\n.users-linkedChild__fallback {\n  margin-top: 7px;\n  padding: 9px 10px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: #ffffff;\n}\n\n.users-linkedChild__card {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.users-linkedChild__avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: #e8f2fb;\n  color: var(--brand-primary, #227ebd);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 30px;\n  overflow: hidden;\n  font-size: 11px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.users-linkedChild__avatar > span {\n  display: block;\n  line-height: 1;\n  transform: translateY(0.5px);\n}\n\n.users-linkedChild__main {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.users-linkedChild__fallback {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.users-linkedChild__main strong,\n.users-linkedChild__main span {\n  display: block;\n}\n\n.users-linkedChild__main strong {\n  color: var(--text-heading, #0f172a);\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 1.25;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.users-linkedChild__main span,\n.users-linkedChild__fallback {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 650;\n  line-height: 1.25;\n}\n.users-filter {\n  grid-template-columns: repeat(3, minmax(150px, 1fr)) auto;\n  align-items: end;\n  column-gap: 16px;\n  padding: 16px;\n  border-color: var(--border-subtle, #dbe3ec);\n  background: var(--surface-subtle, #f8fafc);\n  box-shadow: none;\n}\n\n.users-filter .people-filter__field {\n  gap: 7px;\n}\n\n.users-filter .people-filter__field > span {\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.users-filter .users-filter__select {\n  width: 100%;\n  height: 38px;\n  padding: 0 36px 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  appearance: none;\n  background-color: var(--surface-card, #fff);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 11px center;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 13px;\n  line-height: 1;\n  font-weight: 650;\n  cursor: pointer;\n  transition: border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease;\n}\n\n.users-filter .users-filter__select--placeholder {\n  color: var(--text-muted, #64748b);\n  font-weight: 550;\n}\n\n.users-filter .users-filter__select:hover {\n  border-color: var(--border-strong, #94a3b8);\n}\n\n.users-filter .users-filter__select:focus {\n  outline: none;\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));\n}\n\n.users-filter .users-filter__select option {\n  background: #fff;\n  color: var(--text-strong, #0f172a);\n  font-weight: 500;\n}\n\n.users-filter .people-filter__actions {\n  align-self: end;\n  min-height: 38px;\n  transform: translateY(-9px);\n}\n\n.users-filter .people-filter__actions .people-btn {\n  height: 38px;\n  min-height: 38px;\n}\n\n.people-chipFilter {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n.people-chipFilter legend {\n  margin-bottom: 7px;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 750;\n}\n.people-chipFilter > input {\n  width: 100%;\n  height: 36px;\n  margin-bottom: 8px;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-strong, #142033);\n  font: inherit;\n  font-size: 13px;\n  outline: none;\n}\n.people-chipFilter > input:focus {\n  border-color: var(--action-primary, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);\n}\n.people-chipFilter__body {\n  max-height: 230px;\n  overflow-y: auto;\n}\n.people-chipFilter__group + .people-chipFilter__group {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid var(--border-subtle, #e5e7eb);\n}\n.people-chipFilter__groupTitle {\n  display: flex;\n  align-items: baseline;\n  gap: 7px;\n  margin-bottom: 7px;\n}\n.people-chipFilter__groupTitle strong {\n  color: var(--text-strong, #142033);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n.people-chipFilter__groupTitle span {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n}\n.people-chipFilter__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n.people-chipFilter__chip {\n  display: inline-flex;\n  min-height: 32px;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 10px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  cursor: pointer;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n}\n.people-chipFilter__chip:hover {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eff6ff);\n}\n.people-chipFilter__chip.is-selected:not([style]) {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.people-chipFilter__empty {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n@media (max-width: 760px) {\n  .users-filter {\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\n  }\n}\n\n.eEventPrintModal.modal-dialog {\n  max-width: 760px !important;\n  font-family: var(--font-body, inherit);\n}\n\n.eEventPrintModal .modal-body {\n  padding: 18px 20px 20px !important;\n}\n\n.eEventPrintModal__intro {\n  margin-bottom: 18px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.eEventPrintModal__group + .eEventPrintModal__group {\n  margin-top: 20px;\n}\n\n.eEventPrintModal__groupTitle {\n  margin: 0 0 8px;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.07em;\n  line-height: 1.3;\n  text-transform: uppercase;\n}\n\n.eEventPrintModal__list {\n  display: grid;\n  gap: 8px;\n}\n\n.eEventPrintModal__item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.eEventPrintModal__item:hover:not(:disabled) {\n  border-color: var(--blue-400, #55a4d6);\n  background: var(--blue-50, #eef8ff);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n\n.eEventPrintModal__item:focus-visible {\n  outline: 2px solid var(--blue-500, #2684c7);\n  outline-offset: 2px;\n}\n\n.eEventPrintModal__item:disabled {\n  background: var(--slate-25, #f8fafc);\n  cursor: not-allowed;\n  opacity: 0.62;\n}\n\n.eEventPrintModal__itemIcon {\n  display: inline-flex;\n  width: 38px;\n  height: 38px;\n  flex: 0 0 38px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: var(--blue-50, #eef8ff);\n  color: var(--blue-700, #17659a);\n}\n\n.eEventPrintModal__itemIcon svg {\n  width: 19px;\n  height: 19px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.eEventPrintModal__itemCopy {\n  min-width: 0;\n  flex: 1;\n}\n\n.eEventPrintModal__itemHeading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 750;\n  line-height: 1.35;\n}\n\n.eEventPrintModal__format {\n  display: inline-flex;\n  flex: 0 0 auto;\n  padding: 2px 6px;\n  border-radius: 5px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 9.5px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.eEventPrintModal__itemDescription {\n  display: block;\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.eEventPrintModal__arrow {\n  flex: 0 0 auto;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 24px;\n  line-height: 1;\n}\n\n@media (max-width: 560px) {\n  .eEventPrintModal.modal-dialog {\n    width: calc(100vw - 24px) !important;\n  }\n\n  .eEventPrintModal .modal-body {\n    padding: 15px !important;\n  }\n\n  .eEventPrintModal__item {\n    align-items: flex-start;\n    padding: 11px;\n  }\n\n  .eEventPrintModal__itemHeading {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .eEventPrintModal__arrow {\n    display: none;\n  }\n}\n\n/* Activity report parameters use the same field system as Extended team sheet. */\n.eEventReportParametersModal.modal-dialog {\n  max-width: 660px !important;\n  font-family: var(--font-body, inherit);\n}\n\n.eEventReportParametersModal .modal-content {\n  border-color: var(--border-subtle, #e3e8ef) !important;\n  border-radius: 16px !important;\n}\n\n.eEventReportParametersModal .modal-header {\n  min-height: 76px;\n  padding: 14px 18px !important;\n  background: #fff !important;\n}\n\n.eReportModalTitle {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 12px;\n}\n.eReportModalTitle__icon {\n  display: inline-flex;\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: var(--blue-50, #eef8ff);\n  color: var(--blue-700, #17659a);\n}\n.eReportModalTitle__icon svg {\n  width: 22px;\n  height: 22px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.eReportModalTitle__copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n}\n.eReportModalTitle__name {\n  color: var(--text-strong, #142033);\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n.eReportModalTitle__category {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  font-weight: 500;\n}\n.eEventReportParametersModal .modal-body {\n  padding: 0 !important;\n  background: #fff;\n}\n.eEventReportParametersModal__body .eReportForm {\n  display: block !important;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n}\n.eEventReportParametersModal__body .eReportDescription {\n  margin: 18px 24px 8px;\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 11px;\n  background: var(--slate-25, #f8fafc);\n  color: var(--text-body, #334155);\n  line-height: 1.55;\n}\n.eEventReportParametersModal__body .eReportSection {\n  margin: 16px 24px 0;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border-subtle, #e3e8ef);\n}\n.eEventReportParametersModal__body .eReportSection__heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n.eEventReportParametersModal__body .eReportSection__icon {\n  display: inline-flex;\n  width: 26px;\n  height: 26px;\n  flex: 0 0 26px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: var(--blue-50, #eef8ff);\n  color: var(--blue-700, #17659a);\n  font-size: 12px;\n  font-weight: 800;\n}\n.eEventReportParametersModal__body .eReportSection__title {\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 750;\n}\n.eEventReportParametersModal__body .eReportSection__hint {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n.eEventReportParametersModal__body .eReportDateRange {\n  display: block;\n}\n.eEventReportParametersModal__body .eReportDateRange__picker {\n  width: 100%;\n}\n.eEventReportParametersModal__body .eReportDateRange label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0;\n  color: #526174;\n  font-size: 11.5px;\n  font-weight: 700;\n}\n.eEventReportParametersModal__body .eReportDateRange input {\n  width: 100%;\n  height: 42px;\n  padding: 0 11px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #fff;\n  color: #334155;\n  font: inherit;\n  font-size: 13px;\n}\n.eEventReportParametersModal__body .eReportDateRange input:focus {\n  border-color: #368fca;\n  box-shadow: 0 0 0 3px rgba(54, 143, 202, 0.12);\n  outline: 0;\n}\n.eEventReportParametersModal__body .eReportToggleList {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 11px;\n}\n.eEventReportParametersModal__body .eReportToggle {\n  display: flex;\n  min-height: 56px;\n  align-items: center;\n  gap: 16px;\n  padding: 10px 13px;\n  border-top: 1px solid var(--border-subtle, #e3e8ef);\n  background: #fff;\n}\n.eEventReportParametersModal__body .eReportToggle:first-child {\n  border-top: 0;\n}\n.eEventReportParametersModal__body .eReportToggle__copy {\n  min-width: 0;\n  flex: 1;\n}\n.eEventReportParametersModal__body .eReportToggle__label {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 650;\n}\n.eEventReportParametersModal__body .eReportToggle__hint {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n.eEventReportParametersModal__body .eReportToggle .sit-switch {\n  flex: 0 0 auto;\n  margin: 0;\n}\n.eEventReportParametersModal__body .eReportActions {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-top: 18px;\n  padding: 14px 24px;\n  border-top: 1px solid var(--border-subtle, #e3e8ef);\n  background: var(--slate-25, #f8fafc);\n}\n.eEventReportParametersModal__body .eReportActions__status {\n  flex: 1;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n.eEventReportParametersModal__body .eDsButton {\n  min-height: 40px;\n  padding: 8px 15px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.eEventReportParametersModal__body .eDsButton--secondary {\n  border: 1px solid var(--border-default, #cfd8e3);\n  background: #fff;\n  color: var(--text-strong, #142033);\n}\n.eEventReportParametersModal__body .eDsButton--primary {\n  border: 1px solid var(--blue-600, #1f78b4);\n  background: var(--blue-600, #1f78b4);\n  color: #fff;\n}\n.eEventReportParametersModal__body .eDsButton--primary:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n@media (max-width: 560px) {\n  .eEventReportParametersModal.modal-dialog {\n    width: calc(100vw - 24px) !important;\n  }\n  .eEventReportParametersModal__body .eReportDescription,\n  .eEventReportParametersModal__body .eReportSection {\n    margin-right: 14px;\n    margin-left: 14px;\n  }\n  .eEventReportParametersModal__body .eReportDateRange {\n    grid-template-columns: 1fr;\n  }\n  .eEventReportParametersModal__body .eReportActions {\n    align-items: stretch;\n    flex-direction: column;\n    padding: 12px 14px;\n  }\n  .eEventReportParametersModal__body .eReportActions__status,\n  .eEventReportParametersModal__body .eDsButton {\n    width: 100%;\n  }\n}\n.peopleRoleActionModal.modal-dialog {\n  max-width: 560px !important;\n}\n.peopleRoleActionModal .modal-content {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  overflow: hidden;\n}\n.peopleRoleActionModal .modal-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: #fff;\n}\n.peopleRoleActionModal .modal-title {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));\n  font-size: 18px;\n  font-weight: 800;\n}\n.peopleRoleActionModal .modal-body {\n  padding: 18px 20px 20px !important;\n}\n.userRoleActionForm {\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.userRoleActionForm__intro {\n  margin: 0 0 12px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.userRoleActionForm__summary {\n  min-height: 44px;\n  margin-bottom: 14px;\n  padding: 10px 12px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 8px;\n  background: var(--slate-50, #f8fafc);\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 700;\n}\n.userRoleActionForm__label {\n  display: block;\n  margin-bottom: 7px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 700;\n}\n.userRoleActionForm__list {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n}\n.userRoleActionForm__row {\n  min-height: 44px;\n  margin: 0;\n  padding: 7px 12px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.userRoleActionForm__row:first-child {\n  border-top: 0;\n}\n.userRoleActionForm__row .sit-switch {\n  flex: 0 0 auto;\n  margin: 0;\n}\n.userRoleActionForm__actions {\n  margin: 18px -20px -20px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-50, #f8fafc);\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.userRoleActionForm__actions .sit-btn--primary:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.peopleDangerModal.modal-dialog {\n  max-width: 540px !important;\n}\n.peopleDangerModal .modal-content {\n  overflow: hidden;\n  border: 1px solid #fecaca;\n  border-radius: 14px;\n}\n.peopleDangerModal .modal-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #fee2e2;\n  background: #fff;\n}\n.peopleDangerModal .modal-title {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));\n  font-size: 18px;\n  font-weight: 800;\n}\n.peopleDangerModal .modal-body {\n  padding: 0 !important;\n}\n.peopleDangerModal__content {\n  padding: 20px 20px 0;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.peopleDangerModal__icon {\n  width: 44px;\n  height: 44px;\n  margin-bottom: 14px;\n  border-radius: 12px;\n  background: #fef2f2;\n  color: #b42318;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.peopleDangerModal__icon svg {\n  width: 23px;\n  height: 23px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.peopleDangerModal__copy strong,\n.peopleDangerModal__warning strong {\n  display: block;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.4;\n}\n.peopleDangerModal__copy p,\n.peopleDangerModal__warning p {\n  margin: 5px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.peopleDangerModal__warning {\n  margin-top: 16px;\n  padding: 12px 14px;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  background: #fef2f2;\n}\n.peopleDangerModal__warning strong {\n  color: #991b1b;\n}\n.peopleDangerModal__warning p {\n  color: #7f1d1d;\n}\n.peopleDangerModal__actions {\n  margin: 20px -20px 0;\n  padding: 14px 20px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-50, #f8fafc);\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.peopleDangerModal__actions .sit-btn--danger {\n  border: 1px solid #b42318;\n  background: #b42318;\n  color: #fff;\n}\n.peopleDangerModal__actions .sit-btn--danger:hover {\n  border-color: #912018;\n  background: #912018;\n}\n.eEventReportParametersModal__body .eReportSection__required {\n  margin-left: 3px;\n  color: var(--red-500, #d92d20);\n}\n.eEventReportParametersModal .modal-content,\n.eEventReportParametersModal .modal-body,\n.eEventReportParametersModal__body {\n  overflow: visible !important;\n}\n.eEventReportParametersModal .eReportDateRange .sit-dp__pop {\n  z-index: 1080;\n}\n.accountSetupReminderModal.modal-dialog { max-width: 600px !important; }\n.accountSetupReminderModal .modal-content { border: 0; border-radius: 16px; overflow: hidden; }\n.accountSetupReminderModal .modal-header { padding: 18px 22px; border-bottom: 1px solid #e2e8f0; }\n.accountSetupReminderModal .modal-body { padding: 0 !important; }\n.accountSetupReminder { padding: 22px; color: #334155; font-family: var(--font-body, 'Public Sans', system-ui, sans-serif); }\n.accountSetupReminder__summary { display: flex; flex-direction: column; gap: 5px; padding: 16px; border-radius: 12px; background: #eff6ff; }\n.accountSetupReminder__summary strong { color: #0f172a; font-size: 16px; }\n.accountSetupReminder__summary span { color: #475569; font-size: 13px; }\n.accountSetupReminder__notice { margin-top: 12px; padding: 12px 14px; border: 1px solid #fed7aa; border-radius: 10px; background: #fff7ed; color: #9a3412; font-size: 13px; line-height: 1.5; }\n.accountSetupReminder__field { display: flex; flex-direction: column; gap: 7px; margin-top: 20px; }\n.accountSetupReminder__field > span { color: #0f172a; font-size: 13px; font-weight: 700; }\n.accountSetupReminder__field select { width: 100%; height: 42px; padding: 0 12px; border: 1px solid #cbd5e1; border-radius: 9px; background: #fff; color: #0f172a; font-size: 14px; }\n.accountSetupReminder__field small { color: #64748b; line-height: 1.45; }\n.accountSetupReminder__error { margin-top: 14px; padding: 11px 13px; border-radius: 9px; background: #fef2f2; color: #b42318; font-size: 13px; }\n.accountSetupReminder__success { display: flex; align-items: center; flex-direction: column; padding: 12px 20px 8px; text-align: center; }\n.accountSetupReminder__successIcon { display: grid; width: 64px; height: 64px; margin-bottom: 16px; place-items: center; border: 8px solid #dcfae6; border-radius: 50%; background: #17b26a; color: #fff; font-size: 22px; box-shadow: 0 0 0 6px #ecfdf3; }\n.accountSetupReminder__successEyebrow { margin-bottom: 7px; color: #067647; font-size: 12px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; }\n.accountSetupReminder__success strong { max-width: 410px; color: #101828; font-size: 21px; line-height: 1.3; }\n.accountSetupReminder__success p { margin: 10px 0 0; color: #475467; font-size: 14px; line-height: 1.5; }\n.accountSetupReminder__success small { max-width: 430px; margin-top: 16px; padding: 11px 14px; border-radius: 10px; background: #f0f9ff; color: #475467; font-size: 12px; line-height: 1.5; }\n.accountSetupReminder__actions { display: flex; justify-content: flex-end; gap: 10px; margin: 22px -22px -22px; padding: 14px 22px; border-top: 1px solid #e2e8f0; background: #f8fafc; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
